import Service from '../../balancer-farm-subgraph.service';
import queryBuilder from './query';
import { FarmingInfo, QueryBuilder } from '../../types';

export default class PoolActivities {
  service: Service;
  query: QueryBuilder;

  constructor(service: Service, query: QueryBuilder = queryBuilder) {
    this.service = service;
    this.query = query;
  }

  public async get(args = {}, attrs = {}): Promise<FarmingInfo> {
    const query = this.query(args, attrs);
    const data = await this.service.client.get(query);
    return data.farmingInfo;
  }

  serializeActivity(poolActivities: FarmingInfo[]) {
    return poolActivities;
  }
}
